import React, { useEffect, useState } from "react";
import { GridCell } from "../../atoms/Layout/GridCell/GridCell";
import { GridRow } from "../../atoms/Layout/GridRow/GridRow";
import { Game } from "../../models/Game";
import { DesktopTile, Link } from "../../molecules/Tiles/GameTile";
import { AARPAnalytics } from "../../services/Analytics/AARPAnalytics";
import { Block } from "../../atoms/Layout/Block/Block";
import { H1, H2 } from "../../atoms/Text/Headings";
import { RecommendedGameService } from "../../services/RecommendedGameService";
import styles from "./Search.css";

type RecommendedGamesProps = {
  allGames: Game[];
};

export const RecommendedGames = ({ allGames }: RecommendedGamesProps) => {
  const [recommendedGames, setRecommendedGames] = useState<Game[]>([]);
  const [analyticsUrlParams, setAnalyticsUrlParams] = useState<string | null>(
    null
  );

  useEffect(() => {
    const fetchRecommendedGames = async () => {
      try {
        const { analyticsURLParam, games } =
          await RecommendedGameService.getRecommendedGames();
        setAnalyticsUrlParams(analyticsURLParam);

        if (!games?.length) return;

        const filteredGames = games.slice(0, 9).reduce((acc, gameSlug) => {
          const matchedGame = allGames.find(({ slug }) => slug === gameSlug);
          if (matchedGame) acc.push(matchedGame);
          return acc;
        }, []);

        setRecommendedGames(filteredGames);
      } catch (error) {
        console.error("Error fetching recommended games:", error);
      }
    };

    fetchRecommendedGames();
  }, [allGames, setRecommendedGames]);

  const buildAnalyticsUrl = (url: string): string => {
    if (!analyticsUrlParams) return url;

    return `${url}${url.includes("?") ? "&" : "?"}${analyticsUrlParams}`;
  };

  return (
    recommendedGames.length > 0 && (
      <>
        <Block paddingB="xl" paddingT="md">
          <H2 size="h3">You May Also Like</H2>
        </Block>
        <Row paddingB="md" wrap="wrap">
          {recommendedGames.map((game) => (
            <Cell key={game.slug} size={[4, 6]}>
              <Link
                data-element-description="game tile"
                to={buildAnalyticsUrl(Game.getURLAlias(game))}
                href={buildAnalyticsUrl(game.seo_FinalURL)}
                isFakeGame={game.seo_IsFakeGame}
                {...AARPAnalytics.attr1Get(game.slug)}
                {...AARPAnalytics.attr2Get(game.slug)}
              >
                <DesktopTile resizable={false} hardLink={true} game={game} />
              </Link>
            </Cell>
          ))}
        </Row>
      </>
    )
  );
};

const Row = (props: any) => <GridRow className={styles.row} {...props} />;
const Cell = (props: any) => <GridCell className={styles.cell} {...props} />;
